import { TransferFlowStep } from 'src/features/transfer/steps';

const pageNameMap: Record<number, string> = {
  [TransferFlowStep.CHOOSE_ACCOUNT_TYPE]: 'ChooseAccountType',
  [TransferFlowStep.SPLASH_PAGE]: 'ThingsToKnow',
  [TransferFlowStep.INITIATE_TRANSFER]: 'ExternalAccount|Login',
  [TransferFlowStep.SELECT_EXTERNAL_ACCOUNT]: 'ExternalAccount|AccountSelection',
  [TransferFlowStep.PARTIAL_TRANSFER]: 'ExternalAccount|PartialTransfer',
  [TransferFlowStep.MANUAL_TRANSFER]: 'ExternalAccount|ManualEntry',
  [TransferFlowStep.MANUAL_PARTIAL_TRANSFER]:
    'ExternalAccount|PartialTransferManualEntry',
  [TransferFlowStep.SELECT_INTERNAL_ACCOUNT]: 'TRowePriceAccountSelection',
  [TransferFlowStep.REVIEW_TRANSFER]: 'ReviewTransfer',
  [TransferFlowStep.REQUIRES_PAPERWORK]: 'Docusign',
  [TransferFlowStep.EXTERNAL_ACCOUNT_INCOMPLETE]: 'ExternalAccount|MissingInformation',
};

export const getPageName = (currentStepNum: number): string => {
  return pageNameMap[currentStepNum] || 'UnknownPage';
};
